var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0508 13.4256L15.1666 9.30977",
    stroke: "#051B46",
    strokeWidth: 1.00351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2079 5.05007C20.2384 4.94175 20.2395 4.82726 20.2111 4.71838C20.1826 4.60949 20.1257 4.51015 20.0461 4.43058C19.9666 4.351 19.8672 4.29408 19.7583 4.26565C19.6494 4.23723 19.535 4.23833 19.4266 4.26885L4.22977 8.87699C4.1057 8.912 3.99528 8.98405 3.91325 9.08351C3.83123 9.18297 3.78152 9.30509 3.77076 9.43356C3.76001 9.56202 3.78872 9.69071 3.85306 9.80242C3.91741 9.91413 4.01431 10.0035 4.13083 10.0587L11.0509 13.4258L14.418 20.3451C14.4732 20.4616 14.5626 20.5585 14.6743 20.6229C14.786 20.6872 14.9147 20.7159 15.0431 20.7052C15.1716 20.6944 15.2937 20.6447 15.3932 20.5627C15.4927 20.4806 15.5647 20.3702 15.5997 20.2461L20.2079 5.05007Z",
    stroke: "#051B46",
    strokeWidth: 1.00351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.7ba2770c6c90e2a70b8468eba892f420.svg";
export { ForwardRef as ReactComponent };